export default __webpack_public_path__ + "static/media/ic-copy.190ed947.svg";